import { render, staticRenderFns } from "./settlementDetailModal.vue?vue&type=template&id=6be64098&scoped=true"
import script from "./settlementDetailModal.vue?vue&type=script&lang=js"
export * from "./settlementDetailModal.vue?vue&type=script&lang=js"
import style0 from "./settlementDetailModal.vue?vue&type=style&index=0&id=6be64098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be64098",
  null
  
)

export default component.exports